import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vfs-prod-img-imp-steps',
  templateUrl: './prod-img-imp-steps.component.html',
  styleUrls: ['./prod-img-imp-steps.component.scss']
})
export class ProdImgImpStepsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
